import { ErrorFallbackPageBtn, ErrorFallbackPageIconContainer, ErrorFallbackPageText, ErrorFallbackPageTextContainer, ErrorFallbackPageTitle, ErrorFallbackPageWrapper } from "./errorFallbackPageStyling";

const ErrorFallbackPage = () => {
    return (
        <ErrorFallbackPageWrapper>
            <ErrorFallbackPageIconContainer>
                <img src="https://d292awxalydr86.cloudfront.net/Branding/Anystay+logo+small.svg" width="48" height="48" alt="Anystay logo" />
            </ErrorFallbackPageIconContainer>
            <ErrorFallbackPageTextContainer>
                <ErrorFallbackPageTitle>Something went wrong</ErrorFallbackPageTitle>
                <ErrorFallbackPageText>This page couldn't be loaded, try again.</ErrorFallbackPageText>
            </ErrorFallbackPageTextContainer>
            <ErrorFallbackPageBtn onClick={() => window.location.reload()}>
                Try again
            </ErrorFallbackPageBtn>
        </ErrorFallbackPageWrapper>
    );
};

export default ErrorFallbackPage;
